import { useEffect, useState } from 'react';
import { useParams, usePathname } from 'next/navigation';

import useActiveSocialProfile from '@/utils/hooks/user/useActiveSocialProfile';

// Utils
import { formatUrls } from '@/utils/urls/formatUrl';

// Routes
import {
    ACCOUNT,
    CAPTIONS_LISTS,
    DATA_ACCESS,
    GROUPS,
    INSPIRATION,
    INTEGRATIONS,
    MEDIA_LIBRARY,
    NOTIFICATIONS,
    PLATFORM_OPTIONS,
    REPORTS,
    REPORTS_ACCOUNTS,
    REPORTS_COMPETITORS,
    REPORTS_DASHBOARDS,
    REPORTS_EDIT,
    REPORTS_HASHTAGS,
    SCHEDULER,
    SCHEDULER_FEED_VIEW,
    SECURITY,
    SOCIAL_PROFILES,
    SUBSCRIPTION,
    SUBSCRIPTION_INVOICES,
    THEMES,
    USERS_ROLES
} from '@/lib/routes/privateRoutes';

const URLS_WITHOUT_FIRST_STATS = [
    ACCOUNT,
    DATA_ACCESS,
    USERS_ROLES,
    SOCIAL_PROFILES,
    PLATFORM_OPTIONS,
    SECURITY,
    THEMES,
    SUBSCRIPTION,
    SUBSCRIPTION_INVOICES,
    NOTIFICATIONS,
    INTEGRATIONS,
    GROUPS,
    REPORTS,
    REPORTS_EDIT,
    REPORTS_ACCOUNTS,
    REPORTS_DASHBOARDS,
    REPORTS_COMPETITORS,
    REPORTS_HASHTAGS,
    INSPIRATION,
    SCHEDULER,
    SCHEDULER_FEED_VIEW,
    CAPTIONS_LISTS,
    MEDIA_LIBRARY
];

const useDisplayFirstStatsPanel = () => {
    const { activeSocialProfile } = useActiveSocialProfile();
    const pathname = usePathname();
    const params = useParams();

    const firstStatsProfileAvailable =
        activeSocialProfile?.first_stats ||
        activeSocialProfile?.full_stats ||
        formatUrls(URLS_WITHOUT_FIRST_STATS, params).includes(pathname) ||
        !activeSocialProfile;

    const [hideFirstStatsEmptyState, setHideFirstStatsEmptyState] = useState(
        firstStatsProfileAvailable
    );

    useEffect(() => {
        if (firstStatsProfileAvailable !== hideFirstStatsEmptyState) {
            setHideFirstStatsEmptyState(firstStatsProfileAvailable);
        }
    }, [firstStatsProfileAvailable]);

    return {
        hideFirstStatsEmptyState,
        setHideFirstStatsEmptyState
    };
};

export default useDisplayFirstStatsPanel;
